import {renderComponent, unmountComponent} from '../../index';
import {executeKey} from '../../_legacy/HotKeys/execute';
import {
    clearSessionForms,
    setSavingStatus,
    setNetFormData,
    getCurrentFormTitle,
    setCurrentFormName,
    getFormState,
    setIsFormActive,
    setIsQueryMode,
    setCurrentCell
} from '../../_legacy/Form/actions/forms';
import {getCurrentFormStatusColor, getStatusBorderColor} from '../../_legacy/Form/utils/status';
import {setF11Search, setEmptyState} from '../../_legacy/Filters/actions/filters';
import {fetchSysLangs, getLangNativeName} from '../../Localization/languages';
import {monitorAction, initDataDogRum} from '../../services/datadog';
import {initSaolaService} from '../../services/saola';

import {getIsTokenExpired} from '../../components/Offline/service';

import {
    showOnCrtlZMessages,
    showOnDeleteRecord,
    showConfirmMessage,
    showErrorMessage,
    showInfoMessage,
    showAboutMessage
} from '../Messages/actions/MessageActions';
import {sendMonitor, sendAbortMonitor, sendMonitorSearchResults} from '../../utils/monitoring';
import {featuresIDs, shouldShowFeature} from '../../features/FeaturePopover/constants/map';
import {isOnServer, getServerReason, getTimeStamp} from './invoke/netForm';
import {showFormHelp} from '../Help/actions/helpActions';
import {setMetaData} from '../../constants/metaData';
import {
    showOnboardingDlg,
    resetOnboardingState,
    closeOnboardingDlg
} from '../../features/OnboardingDialog/service/completionState';
import {addEntryIndexedDB} from '../../services/indexDB/indexeddbService';
import {addNewSubFormEntry} from '../../services/indexDB/indexeddbServiceSubForms';
import {addActionsEntry} from '../../services/indexDB/indexeddbServiceActions';

import {
    showSubFormsSuggestion,
    showHomepageSuggestion
} from '../../features/Personalization/actions';

import {
    showReconFeature,
    updatePulseShownCount,
    isAutomation
} from '../../features/FeaturePopover/actions/feature';
import {hideMacroFooter} from '../../_legacy/Macro/utils';
import {stopMacroMessage} from '../../_legacy/Macro/actions/macroActions';
import {showAutomationFeature} from '../../_legacy/Macro/actions/macroActions';
import {getCountry, getLangTitle, getProjType} from '../../Localization';
import {addSortToFilter, refreshReconWithFilters} from '../../_legacy/Searches/actions/filters';
import {setDesignPanelOpen, setLegacyFormSidePanelSubforms} from '../../features/Form/actions/form';
import {
    initLocalStorageRecentItems,
    setRecentItem
} from '../../services/proto/RecentItems/recentItems';
import {
    endDirectActivation,
    restartDirectActivation
} from '../../features/Form/actions/activations';
import {getBreadCrumbs, moveUp, unlockSession} from '../../features/Form/actions/screen';
import {isDevOrPrisoft} from '../../utils/platform';
import {initWASM} from '../../services/wasm/apiService';
import {getSystemLangs} from '../../Localization/languages';
import {bpmRulesStorage} from '../../features/Automations/modules/BPMRules/BPM.rules.storage';
import {alertsToStorageSerializer} from '../../features/Automations/modules/BPMRules/utils/oldToNewDataStructure.serializer';
import {companyStore} from '../../stores/Company/Company.store';
import {clearWizardLog} from '../../features/EOYWizard/actions/dev';
import {clearEOYRemindersStoreData} from '../../features/EOYWizard/actions/reminders';
import {addTileFromMenu} from '../../features/Homepage/actions/dialogs';
import {getHomepageData} from '../../features/Homepage/actions/data';
import {getUserUuid} from '../../_legacy/library/utils/uuid';
import {selectCompanyStore} from '../../features/SelectCompanyDlg/SelectCompanyStore';
import {openVscodeDeeplink} from '../../features/VscodeDeeplink/vscodeDeeplink';
import {
    getMailboxToggleState,
    isNewMailbox
} from '../../components/MailboxSendToggle/actions/serverStorage';
import {getJWTcookieContent} from '../../utils/cookieUtils';

export function publishFuncs() {
    window['renderComponent'] = renderComponent;
    window['umnountReactComponent'] = unmountComponent;
    window['hotkeys'] = {};
    window['hotkeys']['executeKey'] = executeKey;
    window['form'] = {};
    window['form']['setNetFormData'] = setNetFormData;
    window['form']['setCurrentFormName'] = setCurrentFormName;
    window['form']['setF11Search'] = setF11Search;
    window['form']['setSavingStatus'] = setSavingStatus;
    window['form']['setEmptyState'] = setEmptyState;
    window['form']['clearSession'] = clearSessionForms;
    window['form']['getCurrentFormTitle'] = getCurrentFormTitle;
    window['form']['getFormState'] = getFormState;
    window['form']['setIsFormActive'] = setIsFormActive;
    window['form']['getCurrentFormStatusColor'] = getCurrentFormStatusColor;
    window['form']['getStatusBorderColor'] = getStatusBorderColor;
    window['form']['setIsQueryMode'] = setIsQueryMode;
    window['form']['showFormHelp'] = showFormHelp;
    window['form']['hideMacroFooter'] = hideMacroFooter;
    window['form']['stopMacroMessage'] = stopMacroMessage;
    window['form']['fieldChanged'] = setCurrentCell;
    window['form']['refreshReconWithFilters'] = refreshReconWithFilters;
    window['form']['addSortToFilter'] = addSortToFilter;
    window['form']['setSidePanelSubforms'] = setLegacyFormSidePanelSubforms;
    window['form']['setDesignPanelOpen'] = setDesignPanelOpen;
    window['form']['openVscodeDeeplink'] = openVscodeDeeplink;

    window['nform'] = {};
    window['nform']['endDirectActivation'] = endDirectActivation;
    window['nform']['unlockSession'] = unlockSession;
    window['nform']['restartDirectActivation'] = restartDirectActivation;
    window['nform']['moveUp'] = moveUp;
    window['nform']['getBreadCrumbs'] = getBreadCrumbs;

    window['messages'] = {};
    window['messages']['showOnCrtlZMessages'] = showOnCrtlZMessages;

    window['grid'] = {};

    window['searchList'] = {};
    window['messages']['showConfirmMessage'] = showConfirmMessage;
    window['messages']['showErrorMessage'] = showErrorMessage;
    window['messages']['showInfoMessage'] = showInfoMessage;
    window['messages']['showOnDeleteRecord'] = showOnDeleteRecord;
    window['messages']['showAboutMessage'] = showAboutMessage;

    window['uuid'] = {};
    window['uuid']['getUUID'] = getUserUuid;

    window['localization'] = {};
    window['localization']['getLangNativeName'] = getLangNativeName;
    window['localization']['getSystemLangs'] = getSystemLangs;
    window['localization']['fetchSysLangs'] = fetchSysLangs;

    window['monitor'] = {};
    window['monitor']['sendMonitor'] = sendMonitor;
    window['monitor']['sendMonitorSearchResults'] = sendMonitorSearchResults;
    window['monitor']['monitorAction'] = monitorAction;
    window['monitor']['initDataDogRum'] = initDataDogRum;
    window['monitor']['getUiLang'] = getLangTitle;
    window['monitor']['getCountry'] = getCountry;
    window['monitor']['getProjType'] = getProjType;
    window['monitor']['initSaola'] = initSaolaService;

    window['featuresIDs'] = featuresIDs;
    window['features'] = {};
    window['features']['shouldShowFeature'] = shouldShowFeature;
    window['features']['updatePulseCount'] = updatePulseShownCount;
    window['features']['showReconFeature'] = showReconFeature;

    window['metaData'] = {};
    window['metaData']['setMetaData'] = setMetaData;
    window['metaData']['isDevOrPrisoft'] = isDevOrPrisoft;

    window['onboarding'] = {};
    window['onboarding']['showOnboardingDlg'] = showOnboardingDlg;
    window['onboarding']['resetOnboardingState'] = resetOnboardingState;
    window['onboarding']['closeOnboardingDlg'] = closeOnboardingDlg;

    window['indexedDBService'] = {};
    window['indexedDBService']['addEntity'] = addEntryIndexedDB;
    window['indexedDBService']['showHomepageSuggestion'] = showHomepageSuggestion;
    window['indexedDBService']['addNewSubFormEntry'] = addNewSubFormEntry;
    window['indexedDBService']['addActionsEntry'] = addActionsEntry;
    window['indexedDBService']['checkSubFormsSuggestion'] = showSubFormsSuggestion;

    window['features']['showAutomationFeature'] = showAutomationFeature;
    window['features']['isAutomation'] = isAutomation;
    window['features']['getMailboxToggleState'] = getMailboxToggleState;
    window['features']['isNewMailbox'] = isNewMailbox;

    window['commonoidc'] = {};
    window['commonoidc']['getIsTokenExpired'] = getIsTokenExpired;

    window['dataStore'] = {};
    window['dataStore']['setRecentItem'] = setRecentItem;
    window['dataStore']['initLocalStorageRecentItems'] = initLocalStorageRecentItems;

    window['apiService'] = {};
    window['apiService']['initWASM'] = initWASM;

    window['bpm'] = {};
    window['bpm']['clearBPMStorage'] = (session: string) => bpmRulesStorage.removeStorage(session);
    window['bpm']['createStorage'] = (session: string) => bpmRulesStorage.createStorage(session);
    window['bpm']['setRules'] = (session: string, data: object, fromId: string, toId: string) =>
        alertsToStorageSerializer(session, data, fromId, toId);

    window['company'] = {};
    window['company']['changeCurrentCompany'] = (name: string) => companyStore.setCompany(name);
    window['company']['initSelectCompanyStore'] = props => selectCompanyStore.initStoreData(props);
    window['company']['openSelectCompanyDlg'] = () => selectCompanyStore.setIsOpen(true);
    window['company']['updateCompaniesList'] = data => selectCompanyStore.setCompanies(data);

    // EOY open methods
    window['eoy'] = {};
    window['eoy']['clearWizardLog'] = clearWizardLog;
    window['eoy']['clearEOYRemindersStoreData'] = clearEOYRemindersStoreData;

    // Homepage open methods
    window['homepage'] = {};
    window['homepage']['addTileFromMenu'] = addTileFromMenu;
    window['homepage']['getHomepageData'] = getHomepageData;

    window['GeneralPage'] = {};
    window['GeneralPage']['getJWTcookieContent'] = getJWTcookieContent;
}

window.addEventListener(
    'beforeunload',
    function (e) {
        e.preventDefault();
        if (isOnServer() && getServerReason()) {
            const requestTime = (Number(new Date().getTime()) - Number(getTimeStamp())) / 1000;
            sendAbortMonitor(getServerReason(), 'UserAbort', requestTime);
        }
    },
    {once: true}
);
